import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from '@/types/utils';

// ── Enum'lar (backend ile birebir) ──
export enum PackageRequestStatus {
  TALEP_OLUSTURULDU = 'TALEP_OLUSTURULDU',
  ISLEME_ALINDI = 'ISLEME_ALINDI',
  TAMAMLANDI = 'TAMAMLANDI',
  IPTAL = 'IPTAL'
}

export enum PackageRequestPickupType {
  FIRMADAN = 'FIRMADAN',
  FARKLI_ADRES = 'FARKLI_ADRES'
}

export enum PackageRequestLocationSource {
  VENDOR = 'VENDOR',
  MANUAL = 'MANUAL'
}

// ── Label + renk map'leri ──
export const packageRequestStatusLabels: Record<string, string> = {
  TALEP_OLUSTURULDU: 'Talep Oluşturuldu',
  ISLEME_ALINDI: 'İşleme Alındı',
  TAMAMLANDI: 'Tamamlandı',
  IPTAL: 'İptal Edildi'
};

export const packageRequestStatusColors: Record<string, string> = {
  TALEP_OLUSTURULDU: 'orange',
  ISLEME_ALINDI: 'blue',
  TAMAMLANDI: 'green',
  IPTAL: 'red'
};

export const pickupTypeLabels: Record<string, string> = {
  FIRMADAN: 'Firma Adresinden',
  FARKLI_ADRES: 'Farklı Adres'
};

// ── Alt tipler ──
export class RequestLocation {
  source: PackageRequestLocationSource;
  vendorId?: number;
  name: string;
  address: string;
  phone: string;
}

export class DeliveryLocation extends RequestLocation {
  id?: string;
  pieceCount: number;
}

export class ProducedBarcode {
  packageId: number;
  shippingType: number;
  deliveryLocationId: string;
  createdAt: string;
  createdByUserId: number;
}

// ── Ana model ──
export class PackageRequest {
  id: string;
  companyId: number;
  creatorId: number;
  creatorName?: string;
  pickupType: string;
  @Type(() => RequestLocation)
  pickupLocation?: RequestLocation;
  @Type(() => DeliveryLocation)
  deliveryLocations: DeliveryLocation[];
  description?: string;
  status: string;
  vehiclePlanId?: string;
  vehicleRedirectedAt?: string;
  @Type(() => ProducedBarcode)
  producedBarcodes: ProducedBarcode[];
  barcodeProduced: boolean;
  createdAt: string;
  updatedAt: string;
}

// ── Log ──
export class PackageRequestLog {
  id: string;
  packageRequestId: string;
  action: string;
  message: string;
  changes: Record<string, { old: unknown; new: unknown }> | null;
  userId: number;
  userName: string | null;
  userEmail: string | null;
  ipAddress: string | null;
  createdAt: string;
}

// ── Response'lar ──
export class IPackageRequestListResponse extends IPagination {
  @Type(() => PackageRequest)
  results: PackageRequest[];
  total: number;
}

export class IPackageRequestResponse {
  @Type(() => PackageRequest)
  result: PackageRequest;
}

export class IPackageRequestLogsResponse {
  @Type(() => PackageRequestLog)
  results: PackageRequestLog[];
}

// ── Query ──
export class IPackageRequestQueryDto extends IQueryPaginationDto {
  companyId?: number;
  status?: string;
  pickupType?: string;
  search?: string;
  barcodeProduced?: boolean;
  vehicleRedirected?: boolean;
  start_date?: string;
  end_date?: string;
  sort_field?: string;
  sort_order?: 'asc' | 'desc';
}

// ── Body DTO'lar ──
export interface IRequestLocationInput {
  source: PackageRequestLocationSource;
  vendorId?: number;
  name: string;
  address: string;
  phone: string;
}

export interface IDeliveryLocationInput extends IRequestLocationInput {
  pieceCount: number;
}

export class IPostPackageRequestBodyDto {
  companyId: number;
  pickupType: string;
  description?: string;
  pickupLocation?: IRequestLocationInput;
  deliveryLocations: IDeliveryLocationInput[];
}

export class IPatchPackageRequestBodyDto {
  pickupLocation?: IRequestLocationInput;
  deliveryLocations?: IDeliveryLocationInput[];
  description?: string;
}
